'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ui_container_plugin = require('clappr/src/base/ui_container_plugin');

var _ui_container_plugin2 = _interopRequireDefault(_ui_container_plugin);

var _events = require('overrides/clappr/base/events');

var _events2 = _interopRequireDefault(_events);

var _template = require('clappr/src/base/template');

var _template2 = _interopRequireDefault(_template);

var _lodash = require('lodash');

var _error_screen = require('./public/error_screen.html');

var _error_screen2 = _interopRequireDefault(_error_screen);

require('./public/error_screen.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ErrorScreen = function (_UIContainerPlugin) {
    _inherits(ErrorScreen, _UIContainerPlugin);

    _createClass(ErrorScreen, [{
        key: 'name',
        get: function get() {
            return 'error_screen';
        }
    }, {
        key: 'template',
        get: function get() {
            return (0, _template2.default)(_error_screen2.default);
        }
    }, {
        key: 'attributes',
        get: function get() {
            return {
                'data-error': '',
                class: 'error-message'
            };
        }
    }]);

    function ErrorScreen(container) {
        _classCallCheck(this, ErrorScreen);

        var _this = _possibleConstructorReturn(this, (ErrorScreen.__proto__ || Object.getPrototypeOf(ErrorScreen)).call(this, container));

        _this.render();
        return _this;
    }

    _createClass(ErrorScreen, [{
        key: 'bindEvents',
        value: function bindEvents() {
            var _this2 = this;

            this.listenTo(this.container.playback, _events2.default.PLAYBACK_FRAGMENT_LOADED, function (data) {
                return _this2._onFragmentLoaded(data);
            });
            this.listenTo(this.container.playback, _events2.default.PLAYBACK_ERROR, function (e) {
                return _this2._onPlaybackError(e);
            });
        }
    }, {
        key: '_onPlaybackError',
        value: function _onPlaybackError(e) {
            this.show('Playback error');
        }
    }, {
        key: '_onFragmentLoaded',
        value: function _onFragmentLoaded(data) {

            // Check if proper data exist
            if (!data.frag || !data.frag.tagList) {
                return;
            }

            var exinf = (0, _lodash.find)(data.frag.tagList, function (tag) {
                return tag[0] === 'INF';
            });

            if (!exinf) {
                return this.hide();
            }

            if (exinf[2].indexOf('error:') !== -1) {
                var code = exinf[2].replace('error:', '');
                var message = 'Camera problem detected (#' + code + ')';
                if (code === '512') {
                    message = 'Please check your camera username and password (#' + code + ')';
                } else if (['510', '520', '521', '522'].indexOf(code) != -1) {
                    message = 'Cannot access camera, please check your network setup (#' + code + ')';
                }
                // Show FAQ link for camera connection debugging in dashboard. Do not show it in Broadcasting
                // as the viewer cannot fix a camera of someone else.
                if (!this.options.broadcasting) {
                    var helpUrl = 'https://help.angelcam.com/general-guides-and-info/troubleshooting/player-error-codes';
                    message += '<br><a target="_blank" href="' + helpUrl + '">Learn More</a>';
                }
                this.show(message);
            } else {
                this.hide();
            }
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.container.enableMediaControl();
            this.$el.html('');
            this.$el.hide();
        }
    }, {
        key: 'show',
        value: function show(message) {
            this.container.disableMediaControl();
            this.$el.html(this.template({ message: message }));
            this.$el.show();
        }
    }, {
        key: 'render',
        value: function render() {
            this.container.$el.append(this.$el);
            this.hide();
            return this;
        }
    }]);

    return ErrorScreen;
}(_ui_container_plugin2.default);

exports.default = ErrorScreen;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/resources/js/player/overrides/clappr/plugins/error_screen/error_screen.js
// module id = 290
// module chunks = 0